import React, { useState } from "react";
import { Modal } from "reactstrap";
import Cropper from "react-easy-crop";


const CropImg = ({ modal, toggle , img,loadingCrop,ratio, fileName,handleNewFileUpload}) => {
    const [image, setImage] = useState(img);
    const [imgAfterCrop, setImgAfterCrop] = useState("");
    const [crop, setCrop] = useState({ x: 0, y: 0 });
    const [aspectRatio, setAspectRatio] = useState(ratio.x / ratio.y);
    const [zoom, setZoom] = useState(1)
    // const [aspectRatio, setAspectRatio] = useState(16 / 9);

    const onCropComplete = (croppedAreaPercentage, croppedAreaPixels) => {
        // setCroppedArea(croppedAreaPixels);
        onCropDone(croppedAreaPixels)
    };
  
    const onCropDone = async (imgCroppedArea) => {
      let imageObj1 = new Image();
      imageObj1.src = image;
  
      const canvasEle = document.createElement("canvas");
      
      canvasEle.width = imgCroppedArea.width;
      canvasEle.height = imgCroppedArea.height;
  
      const context = canvasEle.getContext("2d");
    
      imageObj1.onload = function () {
        context.drawImage(
          imageObj1,
          imgCroppedArea.x,
          imgCroppedArea.y,
          imgCroppedArea.width,
          imgCroppedArea.height,
          0,
          0,
          imgCroppedArea.width,
          imgCroppedArea.height
        );
  
        let dataURL = canvasEle.toDataURL(fileName?.type);
        setImgAfterCrop(dataURL)
      };
    };

    const getImageMimeType = (base64String) => {
        const dataUrlRegex = /^data:image\/([a-zA-Z]+);base64,/;
        const mimeType = base64String.match(dataUrlRegex);
        return mimeType ? mimeType[1] : null;
    }
    const convertBase64ToBuffer = (base64String) => {
        try {
          const sanitizedBase64 = base64String.replace(/^data:image\/[a-z]+;base64,/, '');
          const byteCharacters = atob(sanitizedBase64);
          const byteNumbers = new Array(byteCharacters.length);
      
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
      
          return new Uint8Array(byteNumbers);
        } catch (error) {
          return null;
        }
    };
    const submit = ()=> {
        const buffer = convertBase64ToBuffer(imgAfterCrop);
        const blob = new Blob([buffer]);
        const mimeType = getImageMimeType(imgAfterCrop);
        const file = new File([blob], fileName?.name, { type: `image/${mimeType}` });

        handleNewFileUpload(file)
    }

    return (
        <Modal isOpen={modal} toggle={toggle} >
            <div className="container" style={{height: '21rem'}}>
                <Cropper
                    image={image}
                    aspect={aspectRatio}
                    crop={crop}
                    zoom={zoom}
                    onCropChange={setCrop}
                    onCropComplete={onCropComplete}
                    onZoomChange={setZoom}
                    style={{
                        containerStyle: {
                        width: "100%",
                        height: "80%",
                        backgroundColor: "#fff",
                        },
                    }}
                />
                <div className="position-absolute" style={{bottom:'16px', right: '16px'}}>
                    <button className="btn btn-primary"
                        onClick={() => submit()}
                        disabled={loadingCrop}
                    >
                        Submit
                    </button>
                </div>
            </div>
      </Modal>
    );
};

export default CropImg;